import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { scrollTo } from "./Navbar";

const Footer = () => (
  <footer data-testid="footer" className="bg-[#0B1F3A] text-[#F7F2EC] noise-overlay relative">
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto pt-14 pb-10">
      <a href="#top" onClick={(e) => scrollTo(e, "#top")} className="block" data-testid="footer-logo">
        <span className="font-display font-black leading-none text-[18vw] sm:text-[12vw] lg:text-[9rem] tracking-[-0.03em] block">BANY</span>
        <span className="text-xs tracking-[0.5em] font-mono-alt uppercase opacity-80 pl-1">Barbershop</span>
      </a>
      <div className="mt-10 pt-6 border-t border-[#F7F2EC]/25 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p data-testid="footer-address" className="text-xs sm:text-sm opacity-85">
          Corso Giuseppe Mazzini 25A, 28100 Novara · Lun–Sab 09:00–12:30 / 13:30–19:30
        </p>
        <div className="flex flex-wrap items-center gap-x-5 gap-y-3">
          <a href="https://instagram.com/bany.barber" target="_blank" rel="noreferrer" data-testid="footer-instagram-link" className="inline-flex items-center gap-2 text-xs font-mono-alt uppercase tracking-[0.2em] opacity-85 hover:opacity-100">
            <Instagram className="w-4 h-4" strokeWidth={1.8} /> @bany.barber
          </a>
          <Link to="/admin" data-testid="footer-admin-link" className="text-xs font-mono-alt uppercase tracking-[0.2em] opacity-60 hover:opacity-100">Area titolare</Link>
          <p className="text-xs font-mono-alt opacity-70">© {new Date().getFullYear()} BANY BARBERSHOP</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
